

export default {
    props: {
        value: {
            type: Boolean,
            required: true
        },
        type: {
            type: String,
            required: true
        }
    },
    components: {
    },
    created() {
        let t = this;

        t.loadData();
    },
    activated() {
        let t = this;
    },
    methods: {

        close() {
            this.$emit('input', false);
        },

        markRead(item) {

            let t = this;

            item.status = 1;

            axios.put('message/' + item.id, { status: 1 }).then(res => {
                if (res.data.status == 1) {

                }
            });

            setTimeout(function () {
                t.$refs['sc' + item.id][0].close();
                t.list.item.remove(item);

                if (t.type == 'att-calendar')
                    t.$parent.$emit('noticeStats', 'clock_in', -1);
                else if (t.type == 'att-schedule')
                    t.$parent.$emit('noticeStats', 'att', -1);

            }, 300);

        },
        loadData() {

            let t = this;

            let params = {
                type: []
            };

            if (t.type == 'att-calendar')
                params.type = [1, 2, 3].join(',');
            else if (t.type == 'att-schedule')
                params.type = [4, 5, 6, 7, 8, 9, 10, 11, 12].join(',');

            if (t.view == 'unread')
                params.status = 0;
            else if (t.view == 'history') {
                params.status = 1;
                params.created_at = t.selectedDate.format('yyyy-MM-dd') + ',' + t.selectedDate.format('yyyy-MM-dd');
            }

            axios.get('message', { params: params }).then(res => {
                if (res.data.status == 1) {
                    let arr = res.data.options.items;
                    arr.forEach(item => {
                        item.data = JSON.parse(item.data);
                        if (item.data_approved == 1) {
                            item.approved_text = '承認';
                        }
                        else if (item.data_approved == 2) {
                            item.approved_text = '却下';
                        }
                    });
                    t.list.item = arr;
                }
            });

        },

        onDateChange() {
            this.loadData();
        },

        formatter(type, val) {
            if (type === 'year') {
                return `${val}年`;
            } else if (type === 'month') {
                return `${val}月`;
            }
            else if (type === 'day') {
                return `${val}日`;
            }
            return val;
        },

        setView(v) {

            let t = this;

            if (v == t.view) {
                return;
            }

            t.view = v;

            t.loadData();
        }

    },
    data() {
        return {
            show: true,
            view: 'unread',
            showDatePopover: false,
            selectedDate: new Date(),
            minDate: new Date('2025-04-01'),
            list: {
                item: [],
            }
        };
    },
    computed: {},
};
